export default {
  HEADING: 'Nunito',
  BODY: 'Nunito'
};
